/**
 * @generated SignedSource<<1bf92411a22733e8e961d4eacae770a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesCreator_iconicDesignSeriesPage$data = {
  readonly primaryCreator: {
    readonly cmsTopModule: {
      readonly description: string | null;
      readonly mainImage: string | null;
    } | null;
    readonly displayName: string | null;
    readonly linkData: {
      readonly path: string | null;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCreatorCollection_iconicDesignSeriesPage">;
  readonly " $fragmentType": "DesignSeriesCreator_iconicDesignSeriesPage";
};
export type DesignSeriesCreator_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesCreator_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCreator_iconicDesignSeriesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "primaryCreatorDesignsMaxCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesCreator_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "maxDesignsCount",
          "variableName": "primaryCreatorDesignsMaxCount"
        }
      ],
      "concreteType": "PrimaryCreatorForSeries",
      "kind": "LinkedField",
      "name": "primaryCreator",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesignSeriesCmsTopModule",
          "kind": "LinkedField",
          "name": "cmsTopModule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mainImage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignSeriesCreatorCollection_iconicDesignSeriesPage"
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};

(node as any).hash = "af54ae49013575c61a36ba6163d7248c";

export default node;
